export const isNumeric = (value: string) => /^\d+$/.test(value)
